<template>
  <div class="tabs">
    <tab
      v-for="(tab, index) of tabs"
      :key="'project-modal-tab' + index"
      :icon="tab.icon"
      :txt="tab.title"
      :active="tabIndex === index"
      :index="index"
      :onClick="onClick"
    />
  </div>
</template>

<script>
import Tab from './Tab.vue';

export default {
  name: 'Tabs',
  components: {
    tab: Tab,
  },
  props: {
    tabs: Array,
    tabIndex: Number,
    onClick: Function,
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.tabs {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-wrap: nowrap;
}
</style>
